import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';

/*  KINTLÉVŐSÉGEK – az RLB „Rendezetlen tételek” és „Kiegyenlítések listája” párja: a kiállított, ki nem
 *  egyenlített számlák hátralékkal és késedelemmel, illetve egy időszak befizetései. */
@Component({
  selector: 'app-szamlazo-kintlevosegek',
  templateUrl: './kintlevosegek.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss'],
})
export class KintlevosegekComponent implements OnInit, OnDestroy {
  nezet: 'rendezetlen' | 'kiegyenlitesek' = 'rendezetlen';
  rendezetlen: any[] = [];
  kiegy: any[] = [];
  tol = `${new Date().getFullYear()}-01-01`;
  ig = new Date().toISOString().slice(0, 10);
  csakLejart = false;
  private sub?: Subscription;
  constructor(public sz: SzamlazoService) {}
  get u() { return this.sz.aktiv.ugyfelId; }
  async ngOnInit() { await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) return;
    try { this.rendezetlen = await this.sz.get(`/kintlevosegek/${this.u}`); } catch { this.rendezetlen = []; }
    try { this.kiegy = await this.sz.get(`/kiegyenlitesek/${this.u}?tol=${this.tol}&ig=${this.ig}`); } catch { this.kiegy = []; }
  }
  get lathato() { return this.csakLejart ? this.rendezetlen.filter((x) => x.kesedelem > 0) : this.rendezetlen; }
  get hatralek() { return this.lathato.reduce((n, x) => n + x.hatralek, 0); }
  get lejartOssz() { return this.rendezetlen.filter((x) => x.kesedelem > 0).reduce((n, x) => n + x.hatralek, 0); }
  get befizetve() { return this.kiegy.reduce((n, x) => n + x.osszeg, 0); }
  pdf(x: any) { this.sz.pdf(x.szamla_id || x.id, x.szamlaszam); }
  szam(v: any) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 0 }); }
}
